import {
    Channel,
    DeliveryTimeType,
    DeliveryTypeCategory,
    PaymentType as PaymentTypeEnum,
    Phase,
    State,
} from '@/features/orders/constants/app'

export enum OrderActivityLogType {
    Created = 'created',
    Paid = 'paid',
    Accepted = 'accepted',
    Cancelled = 'cancelled',
    SentToProduction = 'sent_to_production',
    Ready = 'ready',
    Delivering = 'delivering',
    Delivered = 'delivered',
}

export enum OrderActivityActorType {
    Admin = 'admin',
    Driver = 'driver',
    TerminalUserProfile = 'terminal_user_profile',
    Customer = 'customer',
    System = 'system',
}

export interface Order {
    id: string
    acceptedDeliveryTime?: DeliveryTime
    activityLogs?: OrderActivityLog[]
    channel: Channel
    containerItems: ContainerItem[]
    createdAt: string
    currency: string
    customerName?: string
    customerNote?: string
    deliveredAt?: string
    deliveryAddress?: DeliveryAddress
    deliveryPrice?: Price
    deliveryType: DeliveryType
    deliveryZone?: DeliveryZone
    items: Item[]
    paymentType?: PaymentType
    phase: Phase
    phoneNumber?: string
    price: Price
    postponedUntil?: string
    receiptUuid: string | null
    remindAt?: string
    requestedDeliveryTime?: DeliveryTime
    shortCode?: string
    smallOrderSurcharge?: Price
    state: State
    tip?: Price
}

export interface OrderActivityLog {
    actor: OrderActivityActor | null
    occurredAt: string
    payload: OrderActivityLogPayload
    type: OrderActivityLogType | (string & {})
}

export interface OrderActivityActor {
    description: string | null
    id: string | null
    label: string | null
    type: (OrderActivityActorType | (string & {})) | null
}

export interface OrderActivityLogPayload extends Record<string, unknown> {
    deliveryTimeShiftMinutes?: number
    paymentType?: string
}

export interface DeliveryTime {
    type: DeliveryTimeType
    start: string
    end: string
}

interface DeliveryAddress {
    city: string
    street: string
    coordinates?: { lat?: number; lng?: number }
}

export interface DeliveryType {
    typeCategory: DeliveryTypeCategory
}

export interface DeliveryZone {
    id: string
    name: string
    color: string
}

export interface Price {
    amount: string
    currency: string
}

export interface PaymentType {
    type: PaymentTypeEnum
}

export interface Item {
    id: string
    addedItems?: AddedItem[]
    container?: Container
    name: string
    quantity: number
    removedIngredients?: RemovedIngredient[]
    toppings?: Topping[]
    price: Price
}

export type AddedItem = Omit<Item, 'addedItems' | 'removedIngredients' | 'toppings'>

export interface Container {
    id: string
    name?: string
    price: Price
}

export interface ContainerItem {
    id: string
    name?: string
    price: Price
    quantity: number
}

export interface Topping {
    id: string
    name: string
    quantity: number
    price: Price
}

export interface RemovedIngredient {
    id: string
    name: string
}
